/**
 * The sign-in page's platform words and the fact they state (the rule is in
 * `storefrontCopy/shared.ts`): how long a sign-in link works, and the consent line under the form.
 * The same on every store, so never a store's copy.
 */
import type { CopyRun } from "./storefrontCopy/shared.js";
import { STOREFRONT_POLICY_TITLES } from "./storefrontLegal.js";

/** How long a storefront sign-in link works: core mints tokens with it, and the page states it. */
export const SIGN_IN_LINK_TTL_MINUTES = 15;

/**
 * The line under the sign-in form. One form both signs up and signs in, so this is the shopper's
 * assent to the Terms of Service and the Privacy Policy and their word that they are of age (the
 * Terms' age, and core's `KYC_MIN_AGE`).
 */
export const SIGN_IN_CONSENT: readonly CopyRun[] = [
  "By continuing you agree to the ",
  { text: STOREFRONT_POLICY_TITLES.terms, href: "/terms" },
  " and ",
  { text: STOREFRONT_POLICY_TITLES.privacy, href: "/privacy" },
  ", and confirm you are at least 18 years old.",
];
